<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination max-items="10" search :data="subMenus">

          <template slot="thead">
            <vs-th sort-key="sequence" class="w-1/10">{{ $t("sections.system.dataForm.sequence") }}</vs-th>
            <vs-th sort-key="menu" class="w-1/10">{{ $t("sections.system.dataForm.menu") }}</vs-th>
            <vs-th sort-key="name" class="w-2/5">{{ $t("sections.system.dataForm.name") }}</vs-th>
            <vs-th sort-key="route" class="w-1/5">{{ $t("sections.system.dataForm.route") }}</vs-th>
            <vs-th sort-key="status" class="w-1/5">{{ $t("sections.system.dataForm.status") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.sequence">
                {{ tr.sequence }}
              </vs-td>
              <vs-td :data="$t(tr.menu.i18n)">
                {{ $t(tr.menu.i18n) }}
              </vs-td>
              <vs-td :data="$t(tr.i18n)">
                {{ $t(tr.i18n) }}
              </vs-td>
              <vs-td :data="tr.url">
                {{ tr.url }}
              </vs-td>
              <vs-td :data="tr.status">
                <vs-chip :color="getStatusColor(tr.status)" class="product-order-status">{{ tr.status }}</vs-chip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapSystemActions, mapState: mapSystemFields} = createNamespacedHelpers('System')

export default {
  computed: {
    ...mapSystemFields(['subMenus'])
  },
  async created () {
    await this.getSubMenusByMenuId({form: {id: this.$route.params.id}})
  },
  methods: {
    ...mapSystemActions(['getSubMenusByMenuId'])
  }
}
</script>
